import Vue from "vue";
import ResourceService from "./resource.service";

class LongTermsAgreementService extends ResourceService {
  static get resource() {
    return "long-term-agreement";
  }
  
  static updatePaymentSchedule(data) {
    const url = `${this.resource}/payment-schedule`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}

export default LongTermsAgreementService;
